module KendoWidgets
{
	export class ButtonOptions implements kendo.ui.ButtonOptions
	{
		labelText?: string;
		width?: string | number;
		height?: string | number;
		isPrimaryButton?: boolean;
		isDeleteButton?: boolean;
		css?: string;
		tooltip?: string;
		visible?: boolean;
		class?: string;
		badgeSettings?: ButtonBadgeSettings;

		textColor?: ColorEnum | string;
		backgroundColor?: ColorEnum | string;
		border?: boolean;

		labelOutside?: string;
		labelOutsidePosition?: LabelPositionEnum;
		labelOutsideClass?: string;
		labelOutsideWidth?: number;

		click?(e: kendo.ui.ButtonClickEvent): void;
		confirmationMessage?: string;
		enable?: boolean;
		icon?: string;
		iconPosition?: IconPositionEnum;
		imageUrl?: string;
		singleClickTimeout?: number;
	}

	export class Button extends kendo.ui.Button implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.Button; }
		private _firstLoad: boolean;
		private _badge: HTMLElement;
		private _clickedDelay: boolean;

		constructor(element: Element, options?: KendoWidgets.ButtonOptions)
		{
			if (options == null)
				options = new KendoWidgets.ButtonOptions();

			if (options.width == null) options.width = "auto";
			if (options.visible == null) options.visible = true;
			if (options.singleClickTimeout == null) options.singleClickTimeout = 2000;
			if (options.iconPosition == null) options.iconPosition = IconPositionEnum.Left;

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";

			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion

			//#region Height
			if (typeof (options.height) == "number")
				options.height = options.height + "px";

			(element as HTMLElement).style.cssText += "height: " + options.height + " !important";
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).style.cssText += options.css;
			//#endregion

			//#region Visible
			if (options.visible == false)
				(element as HTMLElement).style.cssText += "display: none;";
			//#endregion

			//#region Tooltip
			if (options.tooltip != null)
				(element as HTMLElement).title = options.tooltip;
			//#endregion

			//#region Click
			let clickUserOverride = options.click;
			options.click = function (e: kendo.ui.ButtonClickEvent)
			{
				let kendoButton = (e.sender as KendoWidgets.Button);

				//#region Required cause of kendo's developer
				if (kendoButton._clickedDelay)
				{
					if (clickUserOverride != null)
						clickUserOverride(e);

					kendoButton.enable(true);
					setTimeout(() => kendoButton.enable(true), options!.singleClickTimeout!);
					return;
				}
				//#endregion

				kendoButton.enable(false);
				if (options!.confirmationMessage != null && options!.confirmationMessage!.length > 0)
				{
					kendo.confirm(options!.confirmationMessage!).then(() =>
					{
						if (clickUserOverride != null)
						{
							kendoButton._clickedDelay = true;
							clickUserOverride(e);
							setTimeout(() => kendoButton._clickedDelay = false, 500);
						}

						kendoButton.enable(true);
						setTimeout(() => kendoButton.enable(true), options!.singleClickTimeout!);
					},
						() =>
						{
							kendoButton.enable(true);
							setTimeout(() => kendoButton.enable(true), options!.singleClickTimeout!);
						});
				}
				else
				{
					if (clickUserOverride != null)
						clickUserOverride(e);

					kendoButton.enable(true);
					setTimeout(() => kendoButton.enable(true), options!.singleClickTimeout!);
				}

				e.preventDefault();
				return false;
			}
			//#endregion

			//#region Button type
			if (options.isPrimaryButton != null && options.isPrimaryButton == true)
				element.classList.add("vrKendoPrimaryButton");
			else if (options.isDeleteButton != null && options.isDeleteButton == true)
				element.classList.add("vrKendoDeleteButton");
			//#endregion

			//#region Color
			if (options.backgroundColor != null)
				(element as HTMLElement).style.cssText += "background-color: " + options.backgroundColor;
			if (options.textColor != null)
				(element as HTMLElement).style.cssText += "color: " + options.textColor;
			//#endregion

			//#region Border
			if (options.border === false)
				(element as HTMLElement).style.cssText += "border: none";
			//#endregion

			//#region Class
			if (options.class != null)
				$(element).addClass(options.class);
			//#endregion

			super(element, options);
			let that = this;

			if (!this._firstLoad)
			{
				this._firstLoad = true;
				window.setTimeout(() => $(element).wrap("<span id='" + element.id + "_spanContainer' class='buttonSpanContainerClass' style='position: relative'></span>"));

				//#region Label text into button
				if (options.labelText != null)
				{
					$("#" + element.id + "Label").remove();
					let label = document.createElement("label");
					label.id = element.id + "Label";
					label.textContent = options.labelText;
					label.style.cssText += "cursor: pointer;";
					element.appendChild(label);
				}
				//#endregion

				//#region Badge
				let badgeColor = "#FFF";
				let badgeBackgroundColor = "red";
				let badgeText = "";
				let badgeVisible = false;
				if (options.badgeSettings != null)
				{
					if (options.badgeSettings.text != null) badgeText = String(options.badgeSettings.text);
					if (options.badgeSettings.color != null) badgeColor = options.badgeSettings.color;
					if (options.badgeSettings.backgroundColor != null) badgeBackgroundColor = String(options.badgeSettings.backgroundColor);
					if (options.badgeSettings.visible != null) badgeVisible = options.badgeSettings.visible;
				}

				$("#" + element.id + "Badge").remove();
				let badge = document.createElement("span");
				badge.id = element.id + "Badge";
				badge.textContent = badgeText;
				badge.classList.add("buttonBadgeClass");
				window.setTimeout(() => $(element).after(badge));
				this._badge = badge;

				if (options.tooltip != null)
					badge.title = options.tooltip;

				badge.style.cssText += "color: " + badgeColor + "; background-color: " + badgeBackgroundColor + ";";
				if ((badgeText == "" || badgeText == null) && !badgeVisible)
					$(badge).hide();

				if (options.badgeSettings != null && options.badgeSettings.click != null)
				{
					badge.style.cssText += "cursor: pointer;";
					$(badge).click(() =>
					{
						let badgeClickEvent = new ButtonBadgeClickEvent();
						badgeClickEvent.sender = this;
						badgeClickEvent.text = this.badgeText();
						options!.badgeSettings!.click!(badgeClickEvent);
					});
				}
				else if (options.click != null)
				{
					badge.style.cssText += "cursor: pointer;";
					$(badge).click(() => that.trigger("click"));
				}
				//#endregion
			}

			//#region Label outside
			if (options.labelOutside != null)
			{
				let divContainer = document.createElement("div");
				$(element).wrap(divContainer);

				$("#" + element.id + "LabelOutside").remove();
				let label = document.createElement("label");
				label.id = element.id + "LabelOutside";
				$(label).kendoLabel(
					{
						text: options.labelOutside,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelOutsideClass,
						height: 19,
						fontSize: 14,
						width: (options.labelOutsideWidth != null) ? options.labelOutsideWidth : "auto"
					});

				//#region Label position
				if (options.labelOutsidePosition == null) options.labelOutsidePosition = LabelPositionEnum.Top;
				switch (options.labelOutsidePosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.insertBefore(label, element.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";

							if (options.width == "100%")
								(element as HTMLElement).style.cssText += "width: Calc(100% - " + (label.clientWidth + 5) + "px)";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";

							if (options.width == "100%")
								(element as HTMLElement).style.cssText += "width: Calc(100% - " + (label.clientWidth + 5) + "px)";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.append(label);

							(element as HTMLElement).style.cssText += "width: 100%";
						}
						break;
				}
				//#endregion

				(element.parentElement! as HTMLElement).style.cssText += "width: " + options.width;
				$(element).parent().attr("id", element.id + "Parent");
			}
			//#endregion

			//#region Icon position
			if (options.iconPosition == IconPositionEnum.Right)
			{
				$(element).find(".k-icon").appendTo(element);
				$(element).find(".k-icon")[0].style.cssText += "margin-right: 0px !important; margin-left: 5px !important;";
			}
			//#endregion
		}

		//#region Visible
		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.show();
				else
					this.element.hide();
			}

			return this.element.is(":visible");
		}

		hide()
		{
			this.visible(false);
		}

		show()
		{
			this.visible(true);
		}
		//#endregion

		click()
		{
			this.trigger("click");
		}

		text(text?: string)
		{
			if (text != null)
			{
				//#region Icon or Image
				let spanIcon = this.element.find(".k-icon")[0];
				let spanImage = this.element.find(".k-image")[0];
				this.element[0].innerHTML = "";

				if (spanIcon != null)
					this.element[0].appendChild(spanIcon);

				if (spanImage != null)
					this.element[0].appendChild(spanImage);
				//#endregion

				$("#" + this.element[0].id + "Label").remove();
				let label = document.createElement("label");
				label.id = this.element[0].id + "Label";
				label.textContent = text;
				label.style.cssText += "cursor: pointer;";
				this.element[0].appendChild(label);
			}

			return this.element[0].innerText;
		}

		backgroundColor(color?: string | ColorEnum)
		{
			if (color != null)
				this.element.css("background-color", color);

			return this.element.css("background-color");
		}

		tooltip(text?: string)
		{
			if (text != null)
				this.element.attr("title", text);

			return this.element.attr("title");
		}

		css(css: string)
		{
			this.element[0].style.cssText += css;
		}

		attribute(attributeName?: string, attributeValue?: string)
		{
			if (attributeName != null && attributeValue != null)
				this.element.attr(attributeName, attributeValue);

			if (attributeName != null && attributeValue == null)
				return this.element.attr(attributeName);
			else
				return Array.from(this.element[0].attributes);
		}

		removeAttribute(attributeName: string)
		{
			this.element.removeAttr(attributeName);
		}

		/**
		 * Gets or sets the button icon. WARNING: it works only if the button has an icon set at creation via the ButtonOptions!
		 * @param iconName The name of the icon to set, without k-i- (es. lock for k-i-lock).
		 */
		icon(iconName?: string): string | null
		{
			let iconElement = this.element.children(".k-icon");
			let icons: string[] = [];

			let classes = iconElement.get(0).classList;
			for (let i = 0; i < classes.length; i++)
			{
				let cl = classes.item(i);
				if (cl != null && cl.startsWith("k-i-") && !cl.startsWith("k-i-k-"))
					icons.push(cl);
			}

			if (iconName != null)
			{
				for (let icon of icons)
					classes.remove(icon);

				classes.add("k-i-" + iconName);
				return iconName;
			}
			else
			{
				if (icons.length == 0)
					return null;
				else
					return icons[0].replace("k-i-", "");
			}
		}

		imageUrl(path: string)
		{
			this.element.find("img").attr("src", path);
		}

		//#region Badge
		badgeText(text?: string | number, show?: boolean)
		{
			show = (show == null) ? true : show;
			if (show)
				this.showBadge();

			if (text != null)
				this._badge.textContent = String(text);

			return this._badge.innerHTML;
		}

		badgeVisible(state?: boolean)
		{
			if (state != null)
			{
				if (state) $(this._badge).show();
				else $(this._badge).hide();
			}
			return $(this._badge).is(":visible");
		}

		showBadge()
		{
			this.badgeVisible(true);
		}

		hideBadge()
		{
			this.badgeVisible(false);
		}
		//#endregion

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.prependTo(element);
		}
	}

	Button.fn = Button.prototype;
	Button.fn.options = $.extend(true, {}, kendo.ui.Button.fn.options);
	Button.fn.options.name = "Button";
	kendo.ui.plugin(Button);

	export class ButtonBadgeSettings
	{
		text?: string | number;
		color?: string;
		backgroundColor?: string;
		visible?: boolean;
		click?: (e: ButtonBadgeClickEvent) => void;
	}

	class ButtonBadgeClickEvent
	{
		sender: KendoWidgets.Button;
		text: string;
	}

	export enum IconPositionEnum
	{
		Left,
		Right
	}
}

interface JQuery
{
	kendoButton(options?: KendoWidgets.ButtonOptions): JQuery;
}